import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  constructor(private http: HttpClient) { }

  getHolidaysList(queryParams) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_HOLIDAYS_LIST, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getHolidaysByCooperate(param) {
    const params = new HttpParams({ fromObject: param });

    return this.http.get<any>(urls.BASE_URL + urls.GET_HOLIDAYS_LIST, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  

  // getHolidayById(payload , id) {
  //   return this.http.put<any>(urls.BASE_URL + urls.GET_HOLIDAYS_LIST '+', id)
  //     .pipe(
  //       catchError(errorHandl)
  //     );
  // }

  getHolidayById(id) {
    return this.http.get<any>(urls.BASE_URL  + urls.GET_HOLIDAYS_LIST + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveHoliday(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.GET_HOLIDAYS_LIST, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
  
  updateHoliday(id:any, payload) {
    return this.http.put<any>(urls.BASE_URL + urls.GET_HOLIDAYS_LIST + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}
